const concatProjectTypes = (project) => [
  ...project.bond_projects.map((bp) => ({
    id: bp.bond.id,
    text: bp.bond.type,
  })),
  ...project.commodities.map((c) => ({ id: c.id, text: c.type })),
];

export default concatProjectTypes;
